import React, { PureComponent } from "react";

import styles from "./FlashMessage.local.scss";
import classnames from "classnames";
import _ from "i18n";

export default class FlashMessageComponent extends PureComponent {
  render() {
    const { openFlash, message, status } = this.props;

    let statusIcon = "icon-check";
    let title = _("Success");

    switch (status) {
      case "ERROR":
        statusIcon = "icon-close";
        title = _("Error");
        break;
      case "WARNING":
        statusIcon = "icon-power";
        title = _("Warning");
        break;
      default:
    }

    return (
      <div
        className={classnames(
          styles.flashMessage,
          styles[status.toLowerCase()],
          openFlash ? styles.opened : ""
        )}
      >
        <i className={classnames("icon", statusIcon)} />
        <div className={styles.body}>
          <h5>{title}</h5>
          <p>{message}</p>
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Layout/FlashMessage/FlashMessageComponent.js